import { Button, CircularProgress } from '@mui/material';
import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import useExcelExport, { EXCEL_EXPORT_VARIANTS } from '../../../hooks/useExcelExport';

const ExportParkingsButton = ({ total = 1000 }) => {
    const { isLoading, handleExport } = useExcelExport();

    return (
        <Button
            sx={{ m: 1 }}
            onClick={() => handleExport(total, EXCEL_EXPORT_VARIANTS.PARKINGS)}
            startIcon={isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
            disabled={isLoading}
        >
            Parkolások exportálása
        </Button>
    );
};

export default ExportParkingsButton;
